import moment from 'moment';
import _ from 'lodash';
import { notificationItem as strings } from 'ui/constants/strings';

const momentOption = [
  'years',
  'months',
  'weeks',
  'days',
  'hours',
  'minutes',
  'seconds',
];

const getTimePassed = (apiTime, unit, toTime) => {
  if (toTime) {
    return Math.floor(moment(toTime).diff(apiTime, unit, true));
  }
  const timeNow = moment.utc();
  return Math.floor(timeNow.diff(apiTime, unit, true));
};

const constructTimeString = (time, format) => {
  if (format === 'seconds') {
    return `(${strings.timeString[format]})`;
  }
  return `(${time}${strings.timeString[format]}${strings.timeString.ago})`;
};

const constructTimeStamp = (timeNow, lastUpdated) => {
  let timeFormat = 'seconds';
  let timePassed = 0;
  momentOption.some((format) => {
    const temp = getTimePassed(lastUpdated, format, timeNow);
    if (temp && temp > 0) {
      timeFormat = format;
      timePassed = temp;
      return true;
    }
    return false;
  });
  return constructTimeString(timePassed, timeFormat);
};

const alertTypeMapping = {
  SOS: strings.alerts.SOS,
  DoorOpen: strings.alerts.DoorOpen,
  LeaveBed: strings.alerts.LeaveBed,
  default: strings.alerts.default,
};

export const mapAlertTypeToText = alertType => _.get(alertTypeMapping, `${alertType}`, `${alertType}`);

export default {
  constructTimeStamp,
  mapAlertTypeToText,
};
